export const TARIF_IPL_BULANAN = 100000;

export const REKENING_BENDAHARA = {
  bank: "Bank BCA",
  nomor: "5870204291 (Rekening khusus RT)",
  atas_nama: "Meikun Dwi Susanto"
};

export const BULAN = [
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember"
];

export const TAHUN_AWAL = 2022;

export const TAHUN_LIST = [2022, 2023, 2024, 2025, 2026, 2027, 2028];
